import { useQuery } from '@tanstack/react-query'

import { queryConfig, QUERY_DATA } from 'src/service'

import { useMagazineContext } from '../useMagazineContext'
import { useReseller } from '../useReseller/useReseller'
import { IOrderBy } from './types'
import { getProductsFetcher } from './utils'

export const useProducts = (products: string[], orderBy?: IOrderBy) => {
  const { data: reseller, isGenericUser } = useReseller()
  const magazine = useMagazineContext()

  return useQuery(
    [QUERY_DATA.PRODUCTS, products],
    ({ signal }) =>
      getProductsFetcher({ products, orderBy, reseller, isGenericUser, magazine }, { signal }),
    {
      ...queryConfig,
      enabled: Boolean(products.length),
    },
  )
}
